export default __webpack_public_path__ + "static/tooltip-critical-do-light-902a2afcdedb7bcd4038515cafaddaf4.png";